import { cloudFunction } from '../parse';

export const fetchAllSalesChannels = async () => {
  return cloudFunction('fetchAllSalesChannels', {});
};

export const fetchSalesChannelDetails = async (id: string) => {
  return cloudFunction('fetchSalesChannelDetails', { salesChannelId: id });
};

export const updateSalesChannel = async (params: {
  id: string;
  name?: string;
  description?: string;
  inventoryItemsFilter?: any;
  addressId?: any;
  userId?: string;
}) => {
  return cloudFunction('updateSalesChannel', params);
};

export const createSalesChannel = async (params: any) => {
  return cloudFunction('createSalesChannel', params);
};

export const removeInventoryItemFromSalesChannel = async (params: {
  salesChannelId: string;
  inventoryItemId: string;
}) => {
  return cloudFunction('removeInventoryItemFromSalesChannel', params);
};

export const restoreInventoryItemToSalesChannel = async (id: string) => {
  return cloudFunction('restoreInventoryItemToSalesChannel', { id });
};

export const fetchSalesChannelInventoryItems = async (params: {
  page: number;
  limit: number;
  salesChannelId: string;
  filters?: any;
}) => {
  return cloudFunction('fetchSalesChannelInventoryItems', params);
};

export const addInventoryItemsToSalesChannel = async (params: {
  salesChannelId: string;
  inventoryItemIds: string[];
}) => {
  return cloudFunction('addInventoryItemsToSalesChannel', params);
};

export const addSalesChannelsToInventoryItem = async (params: {
  salesChannelIds: string[];
  inventoryItemId: string;
}) => {
  return cloudFunction('addSalesChannelsToInventoryItem', params);
};

export const updateMenuItemInSalesChannel = async (params: {
  salesChannelId: string;
  itemId: string[];
}) => {
  return cloudFunction('updateMenuItemInSalesChannel', params);
};

export const syncMenuForSalesChannel = async (params: {
  salesChannelId: string;
}) => {
  return cloudFunction('syncMenuToSalesChannels', params);
};

export const updatePosStatusOfUberSalesChannel = async (params: {
  salesChannelId: string;
}) => {
  return cloudFunction('updatePosStatusOfUberSalesChannel', params);
};

export const fetchSalesChannelMappingDetails = async (params: {
  id: string;
}) => {
  return cloudFunction('fetchSalesChannelMappingDetails', params);
};

export const updateSalesChannelMappingDetails = async (params: {
  params?: any;
  id: string;
}) => {
  return cloudFunction('updateSalesChannelMappingDetails', params);
};

export const fetchSalesChannelMappingsForInventoryItem = async (params: {
  itemId: string;
}) => {
  return cloudFunction('fetchSalesChannelMappingsForInventoryItem', params);
};

export const salesPersonOrdersSummary = async (params: any) => { 
  return cloudFunction('salesPersonOrdersSummary', params);
};

export const copyCatalogFromSalesChannel = async (params: any) => { 
  return cloudFunction('copyCatalogFromSalesChannel', params);
};
